import { render } from "./blackNameList.vue?vue&type=template&id=cb68da80&scoped=true"
import script from "./blackNameList.vue?vue&type=script&lang=js"
export * from "./blackNameList.vue?vue&type=script&lang=js"

import "./blackNameList.vue?vue&type=style&index=0&id=cb68da80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb68da80"

export default script